import { render, staticRenderFns } from "./studentStatistics.vue?vue&type=template&id=d0d80c38&scoped=true"
import script from "./studentStatistics.vue?vue&type=script&lang=js"
export * from "./studentStatistics.vue?vue&type=script&lang=js"
import style0 from "./studentStatistics.vue?vue&type=style&index=0&id=d0d80c38&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d80c38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0d80c38')) {
      api.createRecord('d0d80c38', component.options)
    } else {
      api.reload('d0d80c38', component.options)
    }
    module.hot.accept("./studentStatistics.vue?vue&type=template&id=d0d80c38&scoped=true", function () {
      api.rerender('d0d80c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/studentStatistics.vue"
export default component.exports